import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { SweetAlertOptions } from 'sweetalert2';
import { MyErrorStateMatcher } from '../login';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  @ViewChild('alertBrowser') private alertBrowser: SwalComponent;

  public alertOption: SweetAlertOptions = {};
  oldpasswordFormControl = new FormControl('', [Validators.required,]);
  newpasswordFormControl = new FormControl('', [Validators.required,]);
  reenternewpassFormControl = new FormControl('', [Validators.required,]);

  matcher = new MyErrorStateMatcher();
  loading = false;
  submitted = false;
  isErrorLogin = false;
  errorMsg: string;
  returnUrl: string;
  isShowPass = true;
  isReset = false;
  resetMsg: string;
  hide = true;
  studentid: number = 0;
  show2: boolean = false;
  show1: boolean = false;
  type: any = "password";
  show: boolean = false;
  type2: string = "password";
  type1: string = "password";
  userinfo: any;


  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private authenticationService: AuthenticationService,
      private alertService: AlertService,
      private globals: Globals,
      private spinner: NgxSpinnerService,
      private http: HttpClient

  ) { }


  ngOnInit() {
    this.userinfo = JSON.parse(localStorage.getItem('userinfo_pc')); console.log(this.userinfo);
    this.studentid = this.userinfo['student_id'];
    
     

  }

  ngAfterViewInit() {
    
  }
 
  onSubmit() {

      this.submitted = true;

      /* stop here if form is invalid */
/*      if (this.oldpasswordFormControl.value == '' || this.newpasswordFormControl.value == '' || this.reenternewpassFormControl.value == '') {
          this.isErrorLogin = false;
          return false;
      }
      else {
          this.loading = true;
          this.spinner.show();
          this.authenticationService.changePassword(this.globals.root_url, this.studentid, this.oldpasswordFormControl.value, this.newpasswordFormControl.value)
              .pipe(first())
              .subscribe(
                  data => {
                      if (data.code == 1000) {

                          this.isErrorLogin = false;
                        
                          this.router.navigateByUrl('/user-login');
                      }
                      else {
                          this.isErrorLogin = true;
                          this.errorMsg = data.status;
                          this.loading = false;
                      }
                      this.spinner.hide();
                  },
                  error => {
                      this.isErrorLogin = true;
                      this.errorMsg = 'Invalid Change Password !!';
                      this.alertService.error(error);
                      this.loading = false;
                      this.spinner.hide();
                  }
              );
      }*/
  }



  showPass() {
      this.isShowPass = false;
  }
  showLogin() {
      this.isShowPass = true;
  }
  login() {
      this.router.navigate(['/userlogin'])
  }


  oldpassShow1() {
    this.show = !this.show;
    if (this.show) {
      this.type = "text";
    }
    else {
      this.type = "password";
    }
  }


  newpassShow1() {

      this.show = !this.show;
      if (this.show) {
          this.type = "text";
      }
      else {
          this.type = "password";
      }
  }
  repassShow2() {
      this.show2 = !this.show2;
      if (this.show2) {
          this.type2 = "text";
      }
      else {
          this.type2 = "password";
      }
  }
}
